export const saveSetting = ({ commit }, payload) => commit('saveSetting', payload)

export const getVoices = ({ commit }) => {
  const voices = window.speechSynthesis.getVoices()
  let osVoices = []
  for (let voice of voices) {
    let v = {
      name: voice.name,
      lang: voice.lang
    }
    osVoices.push(v)
  }
  commit('saveVoices', osVoices)
}
